import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

const leadSchema = z.object({
  name: z.string().trim().min(1).max(120),
  phone: z.string().trim().min(7).max(40),
  email: z.string().trim().email().max(255),
  address: z.string().trim().max(255).optional().default(""),
  service: z.string().trim().max(255).optional().default(""),
  message: z.string().trim().max(2000).optional().default(""),
  source: z.string().trim().max(120).optional().default("website-contact-form"),
  pageUrl: z.string().trim().max(500).optional().default(""),
});

export const submitLead = createServerFn({ method: "POST" })
  .inputValidator((input: unknown) => leadSchema.parse(input))
  .handler(async ({ data }) => {
    const url = process.env.GHL_WEBHOOK_URL;
    if (!url) {
      console.error("GHL_WEBHOOK_URL is not configured");
      return { ok: false, error: "Webhook not configured" };
    }

    const payload = {
      ...data,
      submittedAt: new Date().toISOString(),
    };

    try {
      const res = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      if (!res.ok) {
        const text = await res.text().catch(() => "");
        console.error(`GHL webhook failed [${res.status}]:`, text);
        return { ok: false, error: `Webhook responded ${res.status}` };
      }
      return { ok: true };
    } catch (err) {
      console.error("GHL webhook request failed:", err);
      return { ok: false, error: "Network error reaching webhook" };
    }
  });
